import PropTypes from 'prop-types'
import React from 'react'
import ReactSVG from 'react-svg'

const getVisibleImageTags = (imageTags) => {
  if (!Array.isArray(imageTags)) return []
  return imageTags.filter(tag => tag?.show)
}

const getBottomTags = (visibleTags) => {
  const bottomTags = []

  visibleTags.forEach(tag => {
    if (tag.key === 'discount') {
      const text = tag.text || ''
      const [amount, ...rest] = text.split(/\s+/)
      bottomTags.push({
        key: tag.key,
        order: tag.order,
        type: 'discount',
        amount: amount || '',
        label: rest.join(' ') || '',
        background_color: tag.background_color,
        text_color: tag.text_color,
        opacity: tag.opacity
      })
      return
    }

    if (tag.key === 'installment') {
      if (tag.badge) {
        const { badge } = tag
        bottomTags.push({
          key: `${tag.key}-badge`,
          order: badge.order ?? tag.order,
          type: 'badge',
          unitMonthlyAmount: badge.unitMonthlyAmount,
          label: badge.label,
          background_color: badge.background_color,
          text_color: badge.text_color,
          opacity: badge.opacity
        })
      }
      if (tag.text) {
        bottomTags.push({
          key: `${tag.key}-text`,
          order: tag.order,
          type: 'text',
          text: tag.text,
          background_color: tag.background_color,
          text_color: tag.text_color,
          opacity: tag.opacity
        })
      }
      return
    }

    if (tag.text) {
      bottomTags.push({
        key: tag.key,
        order: tag.order,
        type: 'text',
        text: tag.text,
        background_color: tag.background_color,
        text_color: tag.text_color,
        opacity: tag.opacity
      })
    }
  })

  return bottomTags.sort((a, b) => a.order - b.order)
}

const tagStyle = (tag) => ({
  backgroundColor: tag.background_color,
  color: tag.text_color,
  opacity: tag.opacity
})

export const ImageTags = ({ imageTags }) => {
  const visibleTags = getVisibleImageTags(imageTags)
  const bottomTags = getBottomTags(visibleTags)

  if (!bottomTags.length) return null

  return (
    <div className='vp-detail-image-tags'>
      {bottomTags.map(tag => {
        if (tag.type === 'discount') {
          return (
            <div
              key={tag.key}
              className='vp-detail-image-tag vp-detail-image-tag--discount'
            >
              <div className='vp-detail-image-tag__discount-wrapper'>
                <ReactSVG
                  src='/icons/vh-discount.svg'
                  wrapper='span'
                  className='vp-detail-image-tag__discount-icon'
                  beforeInjection={svg => {
                    svg.setAttribute('width', '50px')
                    svg.setAttribute('height', '50px')
                  }}
                />
                {tag.amount ? (
                  <span className='vp-detail-image-tag__discount-text'>
                    {tag.amount}
                  </span>
                ) : null}
                {tag.label ? (
                  <span className='vp-detail-image-tag__discount-text'>
                    {tag.label}
                  </span>
                ) : null}
              </div>
            </div>
          )
        }

        if (tag.type === 'badge') {
          return (
            <div
              key={tag.key}
              className='vp-detail-image-tag vp-detail-image-tag--badge'
              style={tagStyle(tag)}
            >
              <span className='vp-detail-image-tag__amount'>
                {tag.unitMonthlyAmount != null ? `${tag.unitMonthlyAmount}€` : ''}
              </span>
              <span className='vp-detail-image-tag__label'>{tag.label || ''}</span>
            </div>
          )
        }

        return (
          <div
            key={tag.key}
            className='vp-detail-image-tag'
            style={tagStyle(tag)}
          >
            {tag.text}
          </div>
        )
      })}
    </div>
  )
}

ImageTags.propTypes = {
  imageTags: PropTypes.array
}
